import TYPES from '../types'

export const tempFileListState = {
  selectNsid: '', // 选中的nsid
  selectPid: '', // 选中的pid
}

export const tempFileListMutations = {
  [TYPES.SET_SELECT_NSID](state, obj) { // 保存选中的nsid
    state.tempFileListState.selectNsid = obj
  },
  [TYPES.SET_SELECT_PID](state, obj) { // 保存选中的pid
    state.tempFileListState.selectPid = obj
  },
}
//selectNsid